import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TOKEN_STORAGE_KEY} from '../../security/constants/security.constants';
import {SecurityService} from '../../security/services/security.service';
import {NotificationType} from '../../notifications/notification.model';
import {NotificationService} from '../../notifications/notification.service';
import {Password} from '../password/password.model';
import { APP_ROUTES } from 'src/app/app-routing.const';
import { notify } from '../../utils/function/notification.util';

@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.scss'],
    standalone: false
})
export class PasswordChangeComponent {

  resetToken: string | null = null;
  markWrongPassword = false;

  constructor(
    private securityService: SecurityService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.queryParamMap.subscribe(params => {
      this.resetToken = params.get(TOKEN_STORAGE_KEY);
    });
  }

  changePassword(password: Password) {
    this.securityService.changePassword(
      password.newPassword,
      password.oldPassword,
      this.resetToken ? this.resetToken : undefined
    ).subscribe({
      next: _ => {
       notify(this.notificationService, NotificationType.SUCCESS, 'password-change.notification.change-success');
        this.router.navigate([APP_ROUTES.AUTH.LOGIN]);
      },
      error: error => {
        if (password.oldPassword) {
          notify(this.notificationService, NotificationType.ERROR, 'password-change.notification.wrong-password');
        }
        this.markWrongPassword = true;
        console.warn(error);
      }
    })
  }
}
